import React from 'react';
import Link from '../Link/Link';
var Block = function (props) {
    var title = props.title, text = props.text, background = props.background, framed = props.framed, bordered = props.bordered, inverse = props.inverse, shadow = props.shadow, customClass = props.customClass, href = props.href, to = props.to, children = props.children, className = props.className;
    var getBackgroundClassName = function () {
        if (inverse) {
            switch (background) {
                case 'dark':
                default:
                    return '';
                case 'dark-blue':
                    return 'bg-dark-blue';
            }
        }
        else {
            switch (background) {
                case 'primary':
                case 'sky-blue':
                default:
                    return 'bg-sky-blue-lightest';
                case 'dark-blue':
                    return 'bg-dark-blue';
                case 'transparent':
                    return 'block-transparent';
                case 'neutral':
                    return 'bg-neutral-10';
                case 'white':
                    return 'bg-white';
            }
        }
    };
    var getClassNames = function () {
        var classNames = ['block'];
        classNames.push(getBackgroundClassName());
        if (inverse)
            classNames.push('block-inverse');
        if (bordered)
            classNames.push('block-bordered');
        if (framed)
            classNames.push('block-framed');
        if (shadow)
            classNames.push('block-shadow');
        if (customClass)
            classNames.push(customClass);
        if (className)
            classNames.push(className);
        return classNames.join(' ');
    };
    var renderContent = function () { return (React.createElement(React.Fragment, null,
        title ? React.createElement("h2", null, title) : null,
        children ? children : React.createElement("p", null, text))); };
    return !!to ? (React.createElement(Link, { className: getClassNames(), to: to }, renderContent())) : (React.createElement("div", { className: getClassNames() }, renderContent()));
};
export default Block;
